/**
 * Convierte el HTML generado por Quill a HTML email-friendly.
 *
 * Quill produce HTML "web" con clases CSS (ql-align-center, etc.).
 * Los clientes de email IGNORAN clases y reglas <style>. Solo respetan
 * estilos inline (style="...").
 *
 * Esta función:
 *   - Convierte ql-align-* a style="text-align: ..."
 *   - Convierte ql-indent-* a style="padding-left: Nem"
 *   - Mantiene los estilos inline de Quill (color, background) tal cual
 *   - Limpia el resto de clases ql-*
 *   - Normaliza <p><br></p> (Quill produce esto para párrafos vacíos)
 *
 * NO toca:
 *   - Etiquetas estructurales (<p>, <h1>, <ul>, <li>, etc.)
 *   - Estilos inline ya válidos (style="color: ...")
 *   - Atributos href
 */

export function quillToEmailHtml(html) {
  if (!html) return '';

  // Crear contenedor temporal para manipulación
  const temp = document.createElement('div');
  temp.innerHTML = html;

  // 1. Convertir clases ql-align-* a estilo inline
  temp.querySelectorAll('[class*="ql-align"]').forEach((el) => {
    const match = el.className.match(/ql-align-(\w+)/);
    if (match) {
      const align = match[1];
      const prev = el.getAttribute('style') || '';
      el.setAttribute('style', appendStyle(prev, `text-align: ${align}`));
    }
  });

  // 2. Convertir clases ql-indent-N a padding-left
  temp.querySelectorAll('[class*="ql-indent"]').forEach((el) => {
    const match = el.className.match(/ql-indent-(\d+)/);
    if (match) {
      const nivel = parseInt(match[1], 10);
      const prev = el.getAttribute('style') || '';
      el.setAttribute('style', appendStyle(prev, `padding-left: ${nivel * 1.5}em`));
    }
  });

  // 3. Eliminar TODAS las clases ql-* (ya las hemos traducido a estilos)
  temp.querySelectorAll('[class]').forEach((el) => {
    const clases = el.className.split(/\s+/).filter((c) => !c.startsWith('ql-'));
    if (clases.length === 0) {
      el.removeAttribute('class');
    } else {
      el.className = clases.join(' ');
    }
  });

  // 4. Normalizar <p><br></p> (artefacto de Quill) a párrafos vacíos limpios
  temp.querySelectorAll('p').forEach((p) => {
    if (p.children.length === 1 && p.children[0].tagName === 'BR'
        && !p.textContent.trim()) {
      // Lo dejamos como <p>&nbsp;</p> para que tenga altura en email
      p.innerHTML = '&nbsp;';
    }
  });

  // 5. Links: añadir target="_blank" + rel por seguridad
  temp.querySelectorAll('a[href]').forEach((a) => {
    if (!a.hasAttribute('target')) a.setAttribute('target', '_blank');
    if (!a.hasAttribute('rel')) a.setAttribute('rel', 'noopener noreferrer');
  });

  return temp.innerHTML;
}

/**
 * Añade una declaración CSS a un string de style, sin duplicar punto y coma.
 */
function appendStyle(prev, nueva) {
  const limpio = prev.trim().replace(/;$/, '');
  if (!limpio) return nueva + ';';
  return `${limpio}; ${nueva};`;
}
